import { MapFeaturePattern } from 'features/siteMapViz'
import { FC, MouseEvent, ReactNode, useMemo, useState } from 'react'
import { Marker } from 'react-map-gl'
import { useGeckoTheme } from 'styles/GeckoTheme'
import {
  generateCheckerboardColorCSS,
  generateStripedColorCSS,
  updateColorOpacity,
} from 'utils/colorHelpers'

import { LabelDisplay } from './baseComponents/MarkerLabelDisplay'
import { MarkerPinIcon } from './baseComponents/MarkerPinIcon'

export type MarkerData = {
  id: string
  name: string
  longitude: number
  latitude: number
}

type MapboxUnitMarkerProps = {
  color: string
  pattern: MapFeaturePattern
  extraLabelDisplay: ReactNode
  onClick: (e: MouseEvent) => void
} & MarkerData
export const MapboxUnitFeature: FC<MapboxUnitMarkerProps> = (props) => {
  const { theme } = useGeckoTheme()

  const backgroundColor = useMemo(() => {
    switch (props.pattern) {
      case MapFeaturePattern.Flat:
      case MapFeaturePattern.Metallic:
        return props.color
      case MapFeaturePattern.Stripes:
        return generateStripedColorCSS(
          props.color,
          updateColorOpacity(theme.forecast.background1, 0.8),
          '2px',
          '-45deg'
        )
      case MapFeaturePattern.Checkers:
        return generateCheckerboardColorCSS(
          updateColorOpacity(props.color, 1),
          updateColorOpacity(props.color, 0.5),
          '8px'
        )
    }
  }, [props.color, props.pattern, theme])

  const [showLabel, setShowLabel] = useState(false)

  return (
    <>
      {/* -- Pin -- */}
      <Marker
        longitude={props.longitude}
        latitude={props.latitude}
        anchor={'bottom'}
        style={{ zIndex: 1 }}>
        <MarkerPinIcon
          backgroundColor={backgroundColor}
          borderColor={props.color}
          onMouseEnter={(e) => {
            e.stopPropagation()
            setShowLabel(true)
          }}
          onMouseLeave={() => setShowLabel(false)}
          onClick={props.onClick}
        />
      </Marker>
      {/* -- Label -- */}
      {showLabel && (
        <Marker
          longitude={props.longitude}
          latitude={props.latitude}
          anchor={'bottom'}
          style={{ pointerEvents: 'none', zIndex: 2 }}>
          <LabelDisplay
            name={props.name}
            extraLabelDisplay={props.extraLabelDisplay}
          />
        </Marker>
      )}
    </>
  )
}
